import { GetResponseAnswerData } from "../../../Common/Commands";
import { SurveyEngine_Models_Answer, SurveyEngine_Models_BaseResponse, SurveyEngine_Models_DispoSelectResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_WebLayout } from "../../../api";
import { GetResponse } from "../GetResponse/GetResponse";

interface DispoSelectProps{
  id:number
  message:string,
  answers:SurveyEngine_Models_Answer[]
  defaultAnswer:string
  isError:boolean
  focus:boolean
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

function DispoSelect(props: DispoSelectProps) {

  const transformResponse = (response: SurveyEngine_Models_GetResponseResponse) => {
 
    if(response)
    {
      let res:SurveyEngine_Models_DispoSelectResponse = {
        commandIndex:response.commandIndex,
        //should not override if command type is "Remove"
        commandType: response.commandType?.toLocaleLowerCase() === 'remove' ? "Remove" : "DispoSelect",
        selectedId:response.selectedId
      }
      props.callback(res);
    }

  }

  const transformAnswers = () => {
 
    let data:GetResponseAnswerData[] = props.answers.map(
      (item: SurveyEngine_Models_Answer) => {

        let answer:GetResponseAnswerData = {
          label: item.message!,
          value: item.id!,
          isOpenEnded:false,
          otherValue:""
        }
        return answer;
      });
      return data;
  }


  return (
    <GetResponse id={props.id}
    question={props.message}
    answers={transformAnswers()}
    defaultAnswer={props.defaultAnswer}
    layout={SurveyEngine_Models_WebLayout.VERTICAL}
    isError={props.isError} focus={props.focus}
    callback={transformResponse} ></GetResponse>
  );
}

export default DispoSelect
